module.exports = __webpack_public_path__ + "static/media/prop-6.08e952d3.webp";